export const DEBUG_PERF = process.env.REACT_APP_DEBUG_PERF === 'true';

export function startPerfTimer(label: string) {
    if (!DEBUG_PERF) return undefined;
    console.time(label);
    return label;
}

export function endPerfTimer(label?: string) {
    if (!DEBUG_PERF || !label) return;
    console.timeEnd(label);
}
